import React from 'react'
import { formatAmount } from '@/utils/functions/formatAmount'
import { handleSetMoneySign } from '@/utils/functions/handleSetMoneySign'
import { toCustomTz } from '@/utils/functions/toCustomTz'

import s from './styles.module.scss'

const getFormattedAmounts = (debt) => {
  return {
    totalDebt: formatAmount(debt?.totalDebt),
    lastAmountUnpaid: formatAmount(debt?.lastVoucherUnpaid?.amount),
  }
}

const DebtAlert = ({ debt, country }) => {
  const { totalDebt, lastAmountUnpaid } = getFormattedAmounts(debt)

  const lastPeriodUnpaid = debt?.totalDebt
    ? toCustomTz(debt?.lastVoucherUnpaid?.period, undefined, true, 'MMMM YYYY').toUpperCase()
    : null

  const lastDueDateUnpaid = debt?.totalDebt
    ? toCustomTz(debt?.lastVoucherUnpaid?.dueDate, undefined, true, 'DD-MM-YYYY')
    : null

  return (
    <div className={s.containerDebtAlert}>
      <div className={s.mainItemDebtAlert}>
        <p>
          <span>{`Tu suscripción para el periodo ${lastPeriodUnpaid} vence el ${lastDueDateUnpaid}. Monto a pagar`}</span>{' '}
          <span className={s.debtNumber}>
            {handleSetMoneySign(country)} {lastAmountUnpaid}
          </span>
        </p>
        <p>
          <span>Tu deuda actual es: </span>
          <span className={s.debtNumber}>
            {handleSetMoneySign(country)}
            {totalDebt}
          </span>
        </p>
      </div>
    </div>
  )
}

export default DebtAlert
